export default "__VITE_ASSET__B7oy7qeL__"